var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-body" }, [
    _c(
      "div",
      { staticClass: "left" },
      [
        _c("base-table", {
          attrs: {
            url: "Affiliater/list",
            columns: _vm.$options.affiliaterColumns,
            paginationStorageKey: "affiliateList"
          },
          scopedSlots: _vm._u([
            {
              key: "createdDate",
              fn: function(props) {
                return [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.formatCreatedDate(props.rowData.createdDate))
                    )
                  ])
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d440fc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d440fc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/affiliate/AffiliaterList.vue
// module id = null
// module chunks = 